import React from 'react'
import ForgotPasswordComp from '../components/ForgotPasswordComp'

export default function ForgotPassword() {
  return (
    <ForgotPasswordComp/>
  )
}
